import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    form: {},
    isEdit: false,
    showForm: false
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
